var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.033,
    height: 16.032,
    viewBox: "0 0 16.033 16.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    "data-name": "Group 1392",
    transform: "translate(-1191.999 -312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M248.747.2A.366.366,0,0,0,248.484.1a.381.381,0,0,0-.262.107L242.929,5.5l-.015.015-.007.007c-.007.011-.018.022-.026.033s0,0,0,.007l-.019.03s0,.008-.007.011-.007.019-.011.03,0,0,0,.007l-.942,2.842a.364.364,0,0,0,.089.377.372.372,0,0,0,.262.107.44.44,0,0,0,.118-.019L245.2,8s0,0,.007,0a.131.131,0,0,0,.033-.015.013.013,0,0,0,.008,0l.037-.022c.011-.007.022-.019.033-.026s.007,0,.007-.007.011-.007.015-.015l5.3-5.3a.368.368,0,0,0,0-.521Zm-5.4,6.238L244.4,7.488l-1.567.521Zm1.73.684-1.367-1.367L248.484.988l1.367,1.367Zm0,0",
    transform: "translate(957.289 311.903)",
    fill: "#c00000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M13.164,88.843a.371.371,0,0,0-.37.37V96.12a1.112,1.112,0,0,1-1.109,1.109H1.848A1.112,1.112,0,0,1,.739,96.12V86.281a1.112,1.112,0,0,1,1.109-1.109H8.755a.37.37,0,1,0,0-.739H1.848A1.849,1.849,0,0,0,0,86.281V96.12a1.849,1.849,0,0,0,1.848,1.848h9.838a1.848,1.848,0,0,0,1.848-1.848V89.212A.371.371,0,0,0,13.164,88.843Zm0,0",
    transform: "translate(1191.999 230.065)",
    fill: "#c00000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUser);
export default __webpack_public_path__ + "static/media/EditUser.d28935649c8dcc44cd7d13b783065e2b.svg";
export { ForwardRef as ReactComponent };